export const SAVE_WINDOW_HISTORY_LENGTH = 'SAVE_WINDOW_HISTORY_LENGTH' as const

export const saveWindowHistoryLengthAction = (value: number) => ({
  type: SAVE_WINDOW_HISTORY_LENGTH,
  value,
})
